<button
  class="gw-button gw-w-full"
  [ngClass]="computedClasses"
  [disabled]="disabled"
  [type]="type"
  (click)="onClick($event)"
>
  <span *ngIf="loading" class="gw-button-spinner"></span>

  <ng-container *ngIf="!loading">
    <gatewee-icon
      *ngIf="iconName"
      [icon]="iconName"
      [iconStyle]="variant == 'primary' ? 'on-accent' : variant"
      size="16px"
      [class.opacity-50]="disabled"
    ></gatewee-icon>

    <span
      *ngIf="title"
      [class.gw-hidden]="hideTitleOnSmall"
      [class.sm:gw-inline]="hideTitleOnSmall"
      >{{ title }}</span
    >
  </ng-container>
</button>
